import { render } from "./MultipleInsert.vue?vue&type=template&id=2d2f4462&scoped=true"
import script from "./MultipleInsert.vue?vue&type=script&lang=js"
export * from "./MultipleInsert.vue?vue&type=script&lang=js"

import "./MultipleInsert.vue?vue&type=style&index=0&id=2d2f4462&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2f4462"]])

export default __exports__